import React, {useEffect, useState} from 'react';
import {Trans} from "react-i18next";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import DataForm from "../billingData/DataForm";
import {validateUserInfo, validateUserInfoItem} from "../../../managers/cartManager/validators/userInfoValidator";
import CartManager from "../../../managers/cartManager/cartManager";
import UserInfoContract from "../../../managers/cartManager/contracts/userInfoContract";

function NewAddress({onSubmit}) {
    const [address, setAddress] = useState(new UserInfoContract());
    const [validity, setValidity] = useState({});

    useEffect(() => {
        const shipping = CartManager.getShipping();
        if (shipping.addressType === 'new') {
            setAddress(shipping?.address);
        }
    }, [])

    const onChange = (id, value) => {
        const newAddress = Object.assign({}, address);
        setDataFormItemValidity(id, validateUserInfoItem(id, value));
        newAddress[id] = value;
        setAddress(newAddress);
        CartManager.changeAddress(newAddress);
    }

    const onBlur = (id) => {
        setDataFormItemValidity(id, validateUserInfoItem(id, address[id]));
    }

    const setDataFormItemValidity = (id, error) => {
        const newValidity = Object.assign({}, validity);
        newValidity[id] = error;
        setValidity(newValidity);
    }

    const handleSubmit = () => {
        const validity = validateUserInfo(address, {email: true, vatNr: true, firmName: true});
        if (Object.keys(validity).length) {
            setValidity(validity);
        } else {
            CartManager.changeAddress(address);
            onSubmit();
        }
    }

    return (
        <>
            <DataForm withoutEmail={true} userInfo={address} onChange={onChange} validity={validity} onBlur={onBlur}/>
            <Box sx={{display: 'flex', justifyContent: 'center', width: '100%', pt: 2}}>
                <Button variant={'contained'} onClick={handleSubmit}><Trans i18nKey={'buttons.submit'}/></Button>
            </Box>
        </>
    );
}

export default NewAddress;
